import dom from "../../../../common/ts/core/dom";
import {EventBus} from "../../../../common/ts/events/EventBus";
import {WlTree} from "../../../../common/ts/webcomponents/tree/tree.component";
import tracking from "../../../../common/ts/core/tracking";
import {SECTION_CLICKED_EVENT_TYPE} from "../../../../common/ts/tracking/constants";
import {Section, SectionId} from "../../../../common/ts/services/Section";

dom.init();
const eventBus: EventBus = EventBus.getInstance()

function init(pageViewId: string) {

    eventBus.emit(new dom.AddClickListenerEvent({
        selector: '.js-geo-children-clear-selection',
        listener: () => {
            (dom.select('.js_filter-geo-children') as WlTree).clear();
        }
    }))

    eventBus.emit(new dom.AddClickListenerEvent({
        selector: '.js-geo-children-select-all',
        listener: () => {
            (dom.select('.js_filter-geo-children-dropdown') as WlTree).selectAll();
            trackClick(pageViewId)
        }
    }))
}

function trackClick(pageViewId: string) {
    EventBus.getInstance().emit(new tracking.TrackWebTrackingEvent({
        type: SECTION_CLICKED_EVENT_TYPE,
        serpUrl: window.location.href,
        sectionName: Section.SECTION_DISTRICT_FILTER_SELECT_ALL,
        section: SectionId.SECTION_DISTRICT_FILTER_SELECT_ALL.toString(),
        pageViewId: pageViewId,
    }));
}

export default {
    init,
}